import { Grid, Typography } from '@mui/material';
import { Field, FieldProps } from 'formik';
import React from 'react';
import { FormikEnumerationSelect, FormikNumberFormat } from 'src/common/components/formik';
import { FeeDisplayFrequencyFormEnum } from 'src/features/templates/store/enums';

export function FlatDollarFeeFields(): JSX.Element {
  return (
    <Grid item xs={12}>
      <Typography style={{ paddingBottom: '10px', alignSelf: 'flex-start' }}>
        Calculated daily based on the entered rate and portfolio balance. All values are annual and will be pro-rated for the billing period.
        <b> Please note that the Amount ($) is inclusive of GST.</b>
      </Typography>
      <Grid container justifyContent="flex-start" spacing={2}>
        <Grid item xs={6}>
          <Field name={'feeTiers[0].valueWithGst'}>
            {(fieldProps: FieldProps) => {
              return (
                <FormikNumberFormat
                  formikFieldProps={fieldProps}
                  numberFormatProps={{
                    placeholder: '$0.00',
                    isNumericString: true,
                    allowNegative: false,
                    decimalScale: 2,
                    thousandSeparator: true,
                    prefix: '$',
                    name: fieldProps.field.name,
                    label: 'Amount ($)'
                  }}
                  isFloatValue={true}
                  fullWidth={true}
                />
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={6}>
          <Field
            component={FormikEnumerationSelect}
            type={FeeDisplayFrequencyFormEnum}
            showNone={false}
            name="displayFrequencyId"
            label="Frequency"
            fullWidth
            valueIsId={true}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
